import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { Card } from 'components';

interface UnumApplicationStatementProps {
  statement: {
    StatementText: string;
    StatementSignee: string;
  };
}

export const UnumApplicationStatement = ({
  statement,
}: UnumApplicationStatementProps) => {
  const { t } = useTranslation('enrollment.plugins');

  return (
    <Card
      additionalClasses="card"
      dataTestId="enrollment-unum-statement-card"
      showBorder
    >
      <h4>
        {t('unum.Application.statementTitle')}
        <span>
          <span aria-hidden="true" role="presentation" className="red">
            *
          </span>
          <span className="sr-only">{t('common:required')}</span>
        </span>
      </h4>
      <div>
        <Typography
          variant="body1"
          dangerouslySetInnerHTML={{ __html: statement.StatementText }}
          gutterBottom
        />
      </div>
    </Card>
  );
};
